import { createAction } from 'redux-actions'
import get from 'lodash.get'
import findIndex from 'lodash.findindex'

import FileService from '../../services/FileService'
import FILE_TYPES from '../../utils/fileEnums'
import { IS_APPLICATION_LOADING, SHOW_USER_FEEDBACK } from '../../actions/types'
import { fetchUser } from '../../actions/user'
import history from '../../history'
import LoadsService from '../Loads2/service'

import SettingsService from './service'
import * as types from './actionTypes'

export const listAllContacts = (transporterId) => async (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  return SettingsService.listAllContacts(transporterId)
    .then((res) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      if (res) {
        const contacts = res
        dispatch(createAction(types.LIST_ALL_CONTACTS)(contacts))

        dispatch(createAction(IS_APPLICATION_LOADING)(false))

        return contacts
      }
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      return []
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.error(err)
    })
}

export const createContact = (transporterId, payload) => async (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  return SettingsService.createContact(transporterId, payload)
    .then((res) => {
      if (res) {
        dispatch(
          createAction(SHOW_USER_FEEDBACK)({
            feedbackMessage: 'Contato criado com sucesso',
            feedbackTitle: null,
            feedbackType: 'MESSAGE',
            styleFeedbackType: 'success',
            messageTimestamp: new Date().getTime(),
          })
        )
        dispatch(listAllContacts(transporterId))
      }
      return res
    })
    .catch((err) => {
      console.error(err)
    })
    .finally(() => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
}
export const updateContact = (transporterId, contactId, payload) => async (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  return SettingsService.updateContact(transporterId, contactId, payload)
    .then((res) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      if (res) {
        dispatch(
          createAction(SHOW_USER_FEEDBACK)({
            feedbackMessage: 'Contato atualizado com sucesso',
            feedbackTitle: null,
            feedbackType: 'MESSAGE',
            styleFeedbackType: 'success',
            messageTimestamp: new Date().getTime(),
          })
        )
        dispatch(listAllContacts(transporterId))
      }
      return res
    })
    .catch((err) => {
      console.error(err)
    })
    .finally(() => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
}

export const deleteContact = (transporterId, contactId) => async (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  return SettingsService.deleteContact(transporterId, contactId)
    .then((res) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      if (res) {
        dispatch(
          createAction(SHOW_USER_FEEDBACK)({
            feedbackMessage: 'Contato deletado com sucesso',
            feedbackTitle: null,
            feedbackType: 'MESSAGE',
            styleFeedbackType: 'success',
            messageTimestamp: new Date().getTime(),
          })
        )
        dispatch(listAllContacts(transporterId))
      }
      return res
    })
    .catch((err) => {
      console.error(err)
    })
    .finally(() => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
}

export const getCertificateImage = (path, certifications) => (dispatch, state) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(false))
  if (path) {
    FileService.download(path)
      .then((result) => {
        const localCertifications =
          certifications || get(state(), 'settings.transporterInfo.certifications', [])
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        const newCertifications = localCertifications.map((item) => {
          if (item.attachment === path) {
            return {
              ...item,
              serverPath: result,
            }
          }
          return item
        })
        dispatch(createAction(types.FETCH_CERTIFICATIONS_IMAGES)(newCertifications))
      })
      .catch(() => dispatch(createAction(IS_APPLICATION_LOADING)(false)))
  }
}

export const fetchTransporterUserInfo = () => (dispatch) => {
  const path = get(history, 'location.pathname', '')
  if (path.includes('/settings')) {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
  }
  SettingsService.fetchTransporterUserInfo()
    .then((result) => {
      if (result) {
        dispatch(createAction(types.FETCH_TRANSPORTER_INFO)(result))
      }
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}

export const fetchTransporterInfo = () => (dispatch) => {
  const path = get(history, 'location.pathname', '')
  if (path.includes('/settings')) {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
  }
  SettingsService.fetchTransporterInfo()
    .then((result) => {
      if (result) {
        dispatch(createAction(types.SAVE_TRANSPORTER_CONFIGS)(result?.configs || []))
        dispatch(createAction(types.FETCH_TRANSPORTER_INFO)(result))
        result.certifications.map((item) => dispatch(getCertificateImage(item.attachment)))
      }
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}

export const fetchAvailableProperties = () => (dispatch) => {
  SettingsService.fetchAvailableProperties()
    .then((result) => {
      dispatch(createAction(types.FETCH_AVAILABLE_PROPERTIES)(result))
    })
    .catch((err) => {
      console.log(err)
    })
}

export const fetchAvailableCertificates = () => (dispatch) => {
  SettingsService.fetchAvailableCertificates()
    .then((result) => {
      dispatch(createAction(types.FETCH_AVAILABLE_CERTIFICATES)(result))
    })
    .catch((err) => {
      console.log(err)
    })
}

export const updateCertificatesOnState = (certifications) => (dispatch) => {
  dispatch(createAction(types.UPDATE_CERTIFICATES_ON_STATE)(certifications))
}

export const fetchLoadProfileById = (id) => (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  SettingsService.fetchLoadProfileById(id)
    .then((result) => {
      dispatch(createAction(types.FETCH_LOAD_PROFILE_BY_ID)({ id, data: result }))
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}

export const updateTransporterInformation = (allInfo) => (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  SettingsService.updateTransporterInfo(allInfo)
    .then((result) => {
      dispatch(
        createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Dados atualizados com sucesso.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        })
      )
      dispatch(createAction(types.FETCH_TRANSPORTER_INFO)(result))
      dispatch(fetchUser())
      result.certifications.map((item) => dispatch(getCertificateImage(item.attachment)))
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}

export const updateCertificates = (newCertifications) => (dispatch, state) => {
  const newInfo = {
    ...state().settings.transporterInfo,
    certifications: newCertifications,
  }
  dispatch(updateTransporterInformation(newInfo))
}

export const updateRequirements = (newRequirements) => (dispatch, state) => {
  const newInfo = {
    ...state().settings.transporterInfo,
    properties: newRequirements,
  }
  dispatch(updateTransporterInformation(newInfo))
}

export const saveCertificateImage = (file, name, id, expireDate) => (dispatch, state) => {
  if (file) {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    FileService.upload(file, FILE_TYPES.transporter.certificate).then((result) => {
      if (!result) {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        return null
      }
      // const newPayload = { ...payload, profileImage: result }
      const newCertification = {
        attachment: result,
        certificationName: name,
        expireDate,
        systemCertificationId: id,
      }
      const newCertifications = [
        ...state().settings.transporterInfo.certifications,
        newCertification,
      ]
      dispatch(getCertificateImage(result, newCertifications))
      const newInfo = {
        ...state().settings.transporterInfo,
        certifications: newCertifications,
      }
      return dispatch(updateTransporterInformation(newInfo))
    })
  }
}

export const updateBasicInformation = (allInfo) => (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  SettingsService.updateBasicInformation(allInfo)
    .then((result) => {
      dispatch(
        createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Dados atualizados com sucesso.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        })
      )
      dispatch(fetchUser())
      dispatch(createAction(types.FETCH_TRANSPORTER_INFO)(result))
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}
export const updateUserConfigs = (userId, allInfo) => (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  SettingsService.updateUserInfo(userId, allInfo)
    .then((result) => {
      dispatch(
        createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Dados atualizados com sucesso.',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        })
      )
      dispatch(fetchUser())
      dispatch(createAction(types.FETCH_TRANSPORTER_INFO)(result))
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
    })
    .catch((err) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      console.log(err)
    })
}

export const updateCoverPicture = (file) => (dispatch, state) => {
  if (file) {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    FileService.upload(file, FILE_TYPES.transporter.facade).then((result) => {
      if (!result) {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log('Erro ao salvar a foto do usuário')
        return null
      }
      const newInfo = {
        imageFacade: result,
      }
      return dispatch(updateBasicInformation(newInfo))
    })
  }
}

export const updateLogoPicture = (file) => (dispatch, state) => {
  if (file) {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    FileService.upload(file, FILE_TYPES.transporter.avatar).then((result) => {
      if (!result) {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log('Erro ao salvar a foto do usuário')
        return null
      }
      const newInfo = {
        imageLogo: result,
      }
      return dispatch(updateBasicInformation(newInfo))
    })
  }
}

export const updateProfilePicture = (file, user) => (dispatch, state) => {
  if (file) {
    dispatch(createAction(IS_APPLICATION_LOADING)(true))
    FileService.upload(file, FILE_TYPES.user.transporter).then((result) => {
      if (!result) {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
        console.log('Erro ao salvar a foto do usuário')
        return null
      }
      const newUser = {
        flNotifyEmail: user.flNotifyEmail,
        flNotifyWhatsApp: false,
        imageProfile: result,
        name: user.name,
        username: user.username,
        phone: user.phone || '',
      }
      dispatch(updateUserConfigs(user.id, newUser))
    })
  }
}

export const fetchOperationGroups = () => (dispatch) => {
  LoadsService.fetchOperationGroups().then((result) => {
    dispatch(createAction(types.FETCH_OPERATION_GROUPS)(result))
  })
}
